import { Flex, Text, IconButton, Tooltip, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Icons } from './Icons';

interface CopyValueProps {
  value: string;
  label?: string;
  fontSize?: string;
  color?: string;
}

export function CopyValue({
  value,
  label,
  fontSize = 'xs',
  color = 'gray.300',
}: CopyValueProps) {
  const { t } = useTranslation();
  const toast = useToast();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      toast({
        title: t('general.copyToClipboard'),
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: t('general.copyFailed'),
        status: 'error',
        duration: 2000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex alignItems="center" gap={2}>
      <Text fontSize={fontSize} color={color}>
        {label && `${label}: `}
        {value}
      </Text>
      <Tooltip label={t('general.copyToClipboard')}>
        <IconButton
          aria-label={t('general.copyToClipboard')}
          icon={<Icons.ContentCopy boxSize={3} />}
          size="xs"
          variant="ghost"
          onClick={handleCopy}
        />
      </Tooltip>
    </Flex>
  );
}
